export enum ServiceNS {
  App = 'app',
  Accessories = 'accessories',
  Backup = '/backup',
  Log = 'log',
  PlatformToolsTerminal = 'platform-tools/terminal',
  Plugins = '/plugins',
  Status = 'status'
}
